import React, { useState, Fragment } from "react";
import classNames from "classnames";
import ImagePreview from "components/AttachmentPreview/ImagePreview/ImagePreview";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import VideoDisplay from "../../AttachmentPreview/Display/VideoDisplay";
import { ReactComponent as PlayIcon } from "assets/img/icons/peerVideoPlay.svg";
import { useGlobalContext } from "store/contexts/globalContext";

const styles = {
  previewDialog: {
    width: "100%",
    height: "100%",
    backgroundColor: "#000000b0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "white",
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
  },
  videoPreview: {
    cursor: "pointer",
  },
  attachmentPreview: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    objectFit: "cover",
    position: "relative",
  },
};

export default ({
  videoURL,
  thumbnail,
  videoType,
  commentAttachmentPreview = false,
}) => {
  const classes = styles;
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const { microsoftConfigureTab } = useGlobalContext();

  const preventDefaultOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  const showPreviewDailog = () => {
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "-1";
    }

    document.getElementById("right-sidebar").style.zIndex = "-1";
    document.getElementById("header").style.zIndex = "-1";
    setShowPreviewDialog(true);
  };

  const closePreviewDailog = () => {
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "1";
    }

    document.getElementById("right-sidebar").style.zIndex = "1";
    document.getElementById("header").style.zIndex = "1";
    setShowPreviewDialog(false);
  };

  return (
    <Fragment>
      <div
        onClick={showPreviewDailog}
        className={classNames({
          [commentAttachmentPreview]: commentAttachmentPreview ? true : false,
          peerAttachmentPreview: true,
        })}
      >
        <div style={classes.attachmentPreview}>
          <ImagePreview
            attachmentSrc={thumbnail}
            Icon={<PlayIcon style={classes.videoPreview} />}
          />
        </div>
        {/* <VideoPreview
          attachmentSrc={videoURL}
          preview={true}
          icon={<PlayIcon style={classes.videoPreview} />}
          fontSize="30px"
          outlined={true}
        /> */}
      </div>
      {showPreviewDialog && (
        <div style={classes.previewDialog} onClick={closePreviewDailog}>
          <div style={classes.previewDialogBackdrop}></div>
          <div style={classes.closeContainer}>
            <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
          </div>
          <div
            className="imagePreviewContentContainer"
            onClick={preventDefaultOnClick}
          >
            <VideoDisplay
              videoDisplay={{
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                maxWidth: "300px",
                maxHeight: "200px",
              }}
              attachmentSrc={videoURL}
              type={videoType}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};
